import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "24",
  viewBox: "0 0 40 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><linearGradient id=\"i1653277528__a\" x1=\"50%\" x2=\"50%\" y1=\"0%\" y2=\"100%\"><stop offset=\"0%\" stop-color=\"#CFCFCF\"></stop><stop offset=\"100%\" stop-color=\"#A1A1A1\"></stop></linearGradient></defs><g fill=\"none\" fill-rule=\"evenodd\" stroke-linejoin=\"square\" transform=\"translate(-32 -170)\"><rect width=\"38\" height=\"22\" x=\"33\" y=\"171\" fill=\"url(#i1653277528__a)\" stroke=\"#FFF\" stroke-width=\"2\" rx=\"11\"></rect><rect width=\"39\" height=\"23\" x=\"32.5\" y=\"170.5\" stroke=\"#D7D7D9\" rx=\"11.5\"></rect></g>", 2)
  ])))
}
export default { render: render }